<template>
  <BreadCrumb page="Beranda > Pendaftaran > Data Keputusan > Lihat Data Keputusan > Data SK"></BreadCrumb>
  <div class="container content-area">
    <div class="row">
      <div class="col-md-10">
        <h3 class="judul-seksi-sga">Keputusan PSB diterima untuk {{ data.nama_anak }} No Formulir
          {{ data.no_formulir }} </h3>
      </div>
      <div class="col-md-2 text-right my-auto">
        <a href="#" @click="toggleview" class="btn btn-sm btn-light"><i class="fa-solid fa-caret-left"></i></a>
      </div>
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="notes-notification-sga">
      <p><strong>Catatan :</strong><br></p>
      <ul>
        <li>Jika ingin menambahkan attachment, maka pilih file attachment terlebih dahulu sebelum klik tombol tindakan</li>
        <li>Isi alamat email test untuk kirim email test ke alamat tersebut</li>
        <li>Jika ingin menyertakan atau mengganti Dokumen SK, pilih dokumen dahulu sebelum klik tombol tindakan di bawah ini, tombol Lihat Dokumen SK muncul ketika Dokumen SK sudah pernah di upload </li>
        <li>Proses penerbitan nomor surat oleh sistem, dilakukan ketika pengguna menekan tombol lihat lihat surel SK</li>
      </ul>
      <p></p>
    </div>
    <div class="form-general">
      <div class="row">
        <div class="col-md-4">
          <div class="row">
            <div class="col-12 spacer-field-sga">
              <normal-label>No formulir</normal-label>
              <br/>
              <normal-label2>{{ data.no_formulir }}</normal-label2>
            </div>
            <div class="col-12 spacer-field-sga">
              <normal-label>Nama Ananda</normal-label>
              <br/>
              <normal-label2>{{ data.nama_anak }}</normal-label2>
            </div>
            <div class="col-12 spacer-field-sga">
              <normal-label>Nama Orang Tua</normal-label>
              <ul>
                <li>
                  <normal-label2>{{ data.nama_ayah }}</normal-label2>
                </li>
                <li>
                  <normal-label2>{{ data.nama_ibu }}</normal-label2>
                </li>
                <li v-if="data.nama_ayah_tiri">{{ data.nama_ayah_tiri }}</li>
                <li v-if="data.nama_ibu_tiri">{{ data.nama_ibu_tiri }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <h4 style="color: darkorange;">SK Keputusan Diterima</h4>
          <ToggleSwitch v-model="logpelunasan" />
          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-striped " v-show="logpelunasan">
                  <thead>
                  <tr>
                    <th scope="col">Status </th>
                    <th scope="col">Tanggal pengiriman</th>
                    <th scope="col">Info</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(srt,idx) in dataLogSurat" :key="idx">
                    <td>{{srt.log_type}}</td>
                    <td>{{srt.log_date}}</td>
                    <td>{{srt.log_desc}}</td>
                  </tr>
                  </tbody>
                </table>
                <hr>
                <label>Dokumen SK diterima : </label>
                <div class="custom-file">
                  <div v-if="attachmentada" class="mb-2">
                    <FileLister v-if="successloadfile" :filedata="filelist.suratsk.list" :num-visible="filelist.suratsk.size"></FileLister>
                  </div>
                  <ProgressBar v-if="isupload" class="mt-2 mb-2" :value="uploadprogress" style="height: 10px;font-size: 14px"></ProgressBar>
                  <FileUpload v-if="showupload" :class="classupload" :fileLimit="2" :showUploadButton="false" :showCancelButton="false" :multiple="false" :chooseLabel="uploadLabel" @before-send="beforeUpload" name="fileupload" :url=urlupload :auto="true" accept="image/jpg,image/jpeg,application/pdf" :maxFileSize="5000000" @progress="onProgress" @upload="onUpload" @select="onSelect">
                    <template #empty>
                      <p>Drag and drop files to here to upload.</p>
                    </template>
                  </FileUpload>
                  <keterangan-form>Pilih berkas maksimum berukuran 1024kb. Hanya .jpg atau .pdf</keterangan-form>
                </div>
                <hr>
                <table class="table table-striped ">
                  <thead>
                  <tr>
                    <th scope="col">Status lampiran SK  diterima</th>
                    <th scope="col">Tindakan</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Email orang tua</td>
                    <td colspan="3">
                      <div v-for="(email,key,idx) of data.email" v-show="email!=null" :key="idx" class="flex items-center gap-2 mb-2">
                        <Checkbox v-model="emailortu" :inputId="idx" name="category" :value="email" class="mr-2" />
                        ({{key}}) {{ email }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Email test</td>
                    <td colspan="3">
                      <input type="email" class="form-control" v-model="emailtest">
                      <keterangan-form>Untuk kirim ke beberapa email, gunakan pemisah dengan tanda ; (titik koma)</keterangan-form>
                    </td>
                  </tr>
                  <tr>
                    <td>Nomor Surat</td>
                    <td colspan="3">
                      <input type="text" class="form-control" v-model="nomorsurat" placeholder="contoh: 100/SGA/XXX/XXX">
                      <keterangan-form>Masukan nomor surat lengkap, jika kosong sistem akan generate nomor</keterangan-form>
                    </td>
                  </tr>
                  <tr>
                    <td>Diterima dengan syarat/catatan</td>
                    <td colspan="3">
                      <textarea class="form-control textarea-sga" rows="4" required="">
                        [sementara] - Tampilkan hanya ketika diterima dengan catatan
                      </textarea>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span v-if="attachmentada">Sudah diunggah</span>
                      <span v-else>Belum diunggah</span>
                    </td>
                    <td>
                        <LoadSpinner v-if="sedangkirimsuratkeputusan"></LoadSpinner>
                        <button v-show="!sedangkirimsuratkeputusan" @click="lihatsuratkeputusan" class="btn btn-sm btn-success mr-1">Lihat surel SK</button>
                        <button v-show="!sedangkirimsuratkeputusan" @click="kirimsuratkeputusan('test')" class="btn btn-sm btn-success mr-1">Test kirim surel SK</button>
                        <button v-show="!sedangkirimsuratkeputusan" @click="kirimsuratkeputusan('kirim')" class="btn btn-sm btn-success">Kirim surel SK</button>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
                <div class="col-md-11" v-if="messagetrx">
                  <AlertSuccess v-if="successtrx" :message="message"></AlertSuccess>
                  <AlertDanger v-else :message="message"></AlertDanger>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
        </div>
      </div>
    </div>
  </div>
  <Dialog v-model:visible="visible" maximizable modal :header="header" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
    <div v-html="content"></div>
  </Dialog>
</template>

<script>
import Checkbox from 'primevue/checkbox';
import ToggleSwitch from 'primevue/toggleswitch';
import Dialog from 'primevue/dialog';
import BreadCrumb from "@/components/BreadCrumb";
import DashboardServices from "@/services/dashboard.services";
import LoadSpinner from "@/components/LoadSpinner";
import FileUpload from 'primevue/fileupload';
import ProgressBar from 'primevue/progressbar';
import FileLister from "@/components/FileLister";
import AlertDanger from "@/components/AlertDanger";
import AlertSuccess from "@/components/AlertSuccess";
import useValidate from "@vuelidate/core";
import { email } from '@vuelidate/validators'
export default {
  name: "PageViewPSBditerima",
  components: {LoadSpinner, BreadCrumb,Dialog,FileUpload,ProgressBar,FileLister,Checkbox,AlertDanger,AlertSuccess,ToggleSwitch},
  props: {
    data: undefined
  },
  emits: ['change-view'],
  data: () => ({
    v$: useValidate(),
    loading: false,
    logpelunasan: false,
    logkwitansi: false,
    sedangkirimsuratkeputusan: false,
    skterkirim: false,
    pelunasanterkirim: false,
    sedangkirimsuratpelunasan: false,
    response: '',
    message: '',
    success: false,
    dataKeputusan: [],
    visible: false,
    content:"",
    header:"",
    isupload: false,
    successtrx: false,
    uploadprogress:0,
    uploadLabel: 'Pilih',
    classupload:'',
    showupload: Boolean,
    urlupload:"",
    urldownload:"",
    fileattachment:"",
    dataSurat:[],
    attachmentada: false,
    successloadfile: false,
    linkdokumen:"",
    messagetrx:"",
    emailtest:"",
    nomorsurat:"",
    filelist:[],
    emailortu:[],
    dataLogSurat:[],
    dataLogKwitansi:[]
  }),
  computed: {
    disablekirimsk() {
      if (this.data.datacatatan.idemail_keputusan_dikirim === 'Sudah dikirim') {
        return true;
      } else {
        return false;
      }
    },
    disablekirimpelunasan() {
      if (this.data.datacatatan.idemail_uang_pelunasan_dikirim === 'Sudah dikirim') {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    toggleview() {
      this.$emit('change-view', true)
    },
    onProgress(event){
      this.isupload = true;
      this.uploadprogress = event.progress;
    },
    beforeUpload(request){
      let user = JSON.parse(localStorage.getItem('usergemala'));
      request.xhr.setRequestHeader('Authorization', 'Bearer ' + user.token);
      request.formData.append('paramname','suratsk');
      request.formData.append('invid',this.data.invid);
      return request;
    },
    onUpload(event){
      let response = event.xhr.response;
      const obj = JSON.parse(response);
      let message = obj.message;
      if(obj.code===1){
        this.fileattachment = obj.data.fileid;
        this.classupload='bg-success';
        this.$toast.add({ severity: 'success', summary: message, detail: 'File Uploaded', life: 3000 });
      }else{
        this.classupload='bg-danger';
        this.$toast.add({ severity: 'danger', summary: message, detail: 'File Uploaded', life: 3000 });
      }
      this.isupload = false;
      this.attachmentada = true;
      this.getDataUploadedFile();
    },
    onSelect(event){
      if(event.files.length >0){
        //this.uploadLabel3 = event.files[0].name;
      }
      this.fileattachment = '';
    },
    lihatsuratkeputusan(){
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'jenis': 'suratsk',
        'nosurat': this.nomorsurat,
        'attachment': this.fileattachment
      };
      this.sedangkirimsuratkeputusan = true;
      this.content = "";
      let path = '/dashboard/lihatsuratkeputusan';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            if (response.data.status === 200) {
              this.success = true;
              this.content = atob(this.response.data);
              this.skterkirim = true;
              this.header = this.response.nosurat;
              this.visible = true;
            } else {
              this.success = false;
            }
            this.sedangkirimsuratkeputusan = false;
            this.loading = false;
            this.$store.commit('loading', this.loading);
            this.logsurat();
          }
      );
    },
    kirimsuratkeputusan(tipe){
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'formulir': this.data.no_formulir,
        'jenis': 'suratsk',
        'tipe': tipe,
        'email': this.emailtest,
        'emailortu': this.data.email,
        'attachment': this.fileattachment
      };
      this.sedangkirimsuratkeputusan = true;
      this.content = "";
      let path = '/dashboard/kirimsuratkeputusanditerima';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            this.messagetrx = this.message;
            if (response.status === 200) {
              this.successtrx = true;
              this.skterkirim = true;
            } else {
              this.successtrx = false;
            }
            this.sedangkirimsuratkeputusan = false;
            this.loading = false;
            this.$store.commit('loading', this.loading);
            this.logsurat();
          }
      );

    },
    getDataUploadedFile(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {
        paramname:this.data.invid,
        filecat:'suratsk'
      };
      let path = '/dashboard/getListFile';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.successloadfile = true;
              this.filelist = this.response.data;
            }else {
              this.successloadfile = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
    datasurat() {
      this.attachmentada = false
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'jenis': 'suratsk'
      };
      this.sedangkirimsuratpelunasan = true;
      let path = '/dashboard/datasurat';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            if (response.data.status === 200) {
              this.successtrx = true;
              this.dataSurat = this.response.data;
              this.nomorsurat = this.dataSurat.nosurat;
              if (this.dataSurat.attachmentid>0){
                this.attachmentada = true;
                this.linkdokumen = this.dataSurat.link;
              }
            } else {
              this.successtrx = false;
            }
            this.loading = false;
            this.$store.commit('loading', this.loading);
          }
      );
    },
    logsurat() {
      this.attachmentada = false
      this.loading = true;
      this.$store.commit('loading', this.loading);
      let data = {
        'idanak': this.data.idanak,
        'invid': this.data.invid,
        'jenis': 'suratsk'
      };
      this.sedangkirimsuratpelunasan = true;
      let path = '/dashboard/logsurat';
      DashboardServices.postData(data, path).then(
          (response) => {
            this.response = response.data;
            this.message = response.data.message;
            if (response.data.status === 200) {
              this.successtrx = true;
              this.dataLogSurat = this.response.data;
            } else {
              this.successtrx = false;
            }
            this.loading = false;
            this.$store.commit('loading', this.loading);
          }
      );
    }
  },mounted() {
    let path = '/dashboard/uploadFile';
    this.urlupload = DashboardServices.generateUrl(path);
    path = '/download/datasurat';
    this.urldownload = DashboardServices.generateUrl(path);
    this.datasurat();
    this.getDataUploadedFile();
    this.logsurat();
  }, validations() {
    return {
      emailtest: {email}
    }
  }
}
</script>

<style scoped>

</style>